import React from "react";
import "./BrandDealsInterface.css";
import foxtale from "../../Images/foxtale.png";
import foxtale_right from "../../Images/foxtale_right.png";
import meesho from "../../Images/mesho.png";
import milton from "../../Images/milton.png";
import chat from "../../Images/chat.png";

const BrandDealsInterface = () => {
  return (
    <div className="container">
      {/* Brand Deals Section */}
      <div className="section brand-deals">
        <div className="brand-content">
          {/* Brand Logos */}
          <div className="brand-logos">
            <img src={foxtale} className="brand-logo" alt="logo" />
            <img src={foxtale_right} className="brand-logo" alt="logo" />
            <img src={meesho} alt="logo" className="brand-logo" />
            <img src={milton} alt="logo" className="brand-logo" />
          </div>

          {/* Brand Deals Label */}
          <div className="label-container">
            <span className="label">Brand Deals</span>
          </div>

          {/* Heading */}
          <div className="heading">
            <h2 className="brand-deals-h2">Shop With Top Brands</h2>
            {/* <p className="brand-deals-p">around the Block</p> */}
          </div>
        </div>
      </div>

      {/* Link Sharing Section */}
      <div className="section link-sharing">
        <div className="brand-content">
          <div className="chat-main">
            <img src={chat} alt="chat" className="chat-image" />
          </div>
          {/* Automated Link Sharing Label */}
          <div className="label-container">
            <span className="label">Automated Link Sharing</span>
          </div>

          {/* Heading */}
          <div className="heading">
            <h2>Share Business Links</h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandDealsInterface;
